import type { ReferralCommunityMember } from "../../../../Redux/Teams/types";

export type InvitationRecord = {
    id: string;
    dateOfJoining: string;
    partnerNetworkId: string;
    partnerNetworkName: string;
    searchText: string;
};

const formatDateOfJoining = (value?: string) => {
    if (!value) {
        return "N/A";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "N/A";
    }

    return date
        .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        })
        .replace(/\//g, "-");
};

export const mapReferralToInvitationRecord = (
    member: ReferralCommunityMember,
    index: number
): InvitationRecord => {
    const dateOfJoining = formatDateOfJoining(member.doj);
    const partnerNetworkId =
        member.registerId || member.user_id?.registerId || "N/A";
    const partnerNetworkName =
        member.user_name || member.user_id?.fullName || "N/A";
    const searchText = [
        dateOfJoining,
        member.doj,
        partnerNetworkId,
        partnerNetworkName,
        member.user_name,
        member.email_id,
        member.registerId,
        member.Referal_name,
        member.Referal_id,
        member.user_id?.fullName,
        member.user_id?.emailId,
        member.user_id?.registerId,
    ]
        .filter((value): value is string => Boolean(value))
        .join(" ")
        .toLowerCase();

    return {
        id: member._id || member.user_id?._id || `invitation-${index}`,
        dateOfJoining,
        partnerNetworkId,
        partnerNetworkName,
        searchText,
    };
};
